module.exports = __webpack_public_path__ + "img/pic7.3c7a2af2.png";